// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"15cd15b6","686":"3beb82b8","791":"e60eb230"}[chunkId] + ".chunk.js";
};